// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__x6Rc0","placeholdersHeader":"styles_placeholdersHeader__1HnhW","editorStyle":"styles_editorStyle__2-y8y","placeholdersBox":"styles_placeholdersBox__Gos9y"};